import { useEffect, useRef, useState } from 'react';

export default function DraggableWindow({ open, onClose, title, children }) {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  /** @type {any} */
  const modalRef = useRef(null);

  useEffect(() => {
    if (open && modalRef.current) {
      const rect = modalRef.current.getBoundingClientRect();
      setPosition({
        x: (window.innerWidth - rect.width) / 2,
        y: (window.innerHeight - rect.height) / 2,
      });
    }
  }, [open]);

  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (e) => {
      setPosition({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y,
      });
    };

    const handleMouseUp = () => setIsDragging(false);

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const handleMouseDown = (e) => {
    if (e.target.dataset.closeBtn === 'true') return;
    const rect = modalRef.current.getBoundingClientRect();
    dragOffset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
    setIsDragging(true);
  };

  if (!open) return null;

  const windowStyle = {
    position: 'fixed',
    left: position.x,
    top: position.y,
    minWidth: 300,
    maxWidth: 500,
    background: '#fff',
    borderRadius: 10,
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
    overflow: 'hidden',
    userSelect: 'none',
    zIndex: 9999,
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 10px',
    background: '#f5f5f5',
    borderBottom: '1px solid #e0e0e0',
    cursor: isDragging ? 'grabbing' : 'grab',
  };

  const titleStyle = {
    fontWeight: 600,
    fontSize: 16,
  };

  const closeBtnStyle = {
    background: 'transparent',
    border: 'none',
    fontSize: 16,
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: 4,
  };

  const bodyStyle = {
    padding: 8,
    cursor: 'default',
  };

  return (
    <div ref={modalRef} 
// @ts-ignore
    style={windowStyle} onMouseDown={handleMouseDown}>
      <div style={headerStyle}>
        <span style={titleStyle}>{title}</span>
        <button
          style={closeBtnStyle}
          data-close-btn="true"
          onClick={onClose}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#e0e0e0')}
          onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
        >
          ✕
        </button>
      </div>
      <div style={bodyStyle}>{children}</div>
    </div>
  );
}